import type { AttributeValue, Tracer } from '@opentelemetry/api'
import {
  ATTRIBUTE_NAME_ERROR_MESSAGE,
  ATTRIBUTE_NAME_ERROR_TYPE,
  ATTRIBUTE_NAME_LLM_CALL_PROMPTS_JSON,
  ATTRIBUTE_NAME_LLM_CALL_RESPONSES_JSON,
  ATTRIBUTE_NAME_LLM_CALL_TOOL_CALLS_JSON,
  ATTRIBUTE_NAME_MODEL_NAME,
  ATTRIBUTE_NAME_MODEL_PROVIDER,
  ATTRIBUTE_NAME_SESSION_ID,
  ATTRIBUTE_NAME_TOKEN_USAGE_INPUT_TOKENS,
  ATTRIBUTE_NAME_TOKEN_USAGE_OUTPUT_TOKENS,
  ATTRIBUTE_NAME_TOKEN_USAGE_TOTAL_TOKENS,
  SPAN_NAME_LLM_CALL,
} from '../../telemetry/constants'
import { FriskSpan } from './frisk-span'

const FIELDS = {
  sessionId: ATTRIBUTE_NAME_SESSION_ID,
  promptsJson: ATTRIBUTE_NAME_LLM_CALL_PROMPTS_JSON,
  responsesJson: ATTRIBUTE_NAME_LLM_CALL_RESPONSES_JSON,
  toolCallsJson: ATTRIBUTE_NAME_LLM_CALL_TOOL_CALLS_JSON,
  modelName: ATTRIBUTE_NAME_MODEL_NAME,
  modelProvider: ATTRIBUTE_NAME_MODEL_PROVIDER,
  inputTokens: ATTRIBUTE_NAME_TOKEN_USAGE_INPUT_TOKENS,
  outputTokens: ATTRIBUTE_NAME_TOKEN_USAGE_OUTPUT_TOKENS,
  totalTokens: ATTRIBUTE_NAME_TOKEN_USAGE_TOTAL_TOKENS,
  errorType: ATTRIBUTE_NAME_ERROR_TYPE,
  errorMessage: ATTRIBUTE_NAME_ERROR_MESSAGE,
} as const

/** Typed span for a single LLM invocation. */
export class LlmCallSpan extends FriskSpan {
  constructor(args: { tracer: Tracer; parent?: FriskSpan | null }) {
    super({ ...args, spanName: SPAN_NAME_LLM_CALL, attributeFields: FIELDS })
  }

  setAttributes(values: {
    sessionId?: string
    promptsJson?: string
    responsesJson?: string
    toolCallsJson?: string
    modelName?: string
    modelProvider?: string
    inputTokens?: number
    outputTokens?: number
    totalTokens?: number
    errorType?: string
    errorMessage?: string
  }): void {
    this.setAttributesByField(
      values as Record<string, AttributeValue | undefined>,
    )
  }
}
